import { api } from './client';

export const paymentsApi = {
  async createCheckoutSession() {
    // Read from the same key the AuthContext writes (now localStorage,
    // ex-sessionStorage as of May 28 2026 — see AuthContext.jsx).
    const token = localStorage.getItem('haven_token');
    return api.post('/payments/create-checkout-session', {}, token);
  },
};
